import { times } from 'lodash';
import from12amto6am from './chargingPatterns/12am-6am.png';
import { FROM_MIDNINGHT_TO_6AM } from '../constants';

const DST = {
  2021: {
    startHour: 1610,
    endHour: 7322,
  },
};

const dstAdjustedHour = (hour, year) => {
  const { startHour, endHour } = DST[year];
  const isWithinDST = hour >= startHour && hour <= endHour;
  return isWithinDST ? (hour + 1) % 24 : hour % 24;
};

// NOTE: this is not a complete list of leap years, but is sufficient for the data
// provided
const isLeapYear = (year) => [2016, 2020, 2024].includes(year);
const hoursInYear = (year) => (isLeapYear(year) ? 8784 : 8760);

// NOTE: Need to be only monday thru friday.
const chargingPatterns = [
  {
    id: FROM_MIDNINGHT_TO_6AM,
    title: 'Midninght to 6 a.m',
    value: '$',
    loadProfile: {
      data: (year) =>
        times(hoursInYear(year), (i) => {
          const date = new Date(year, 0, 1, 0, 0, 0);
          date.setHours(i);
          const hour = dstAdjustedHour(date.getHours(), year);
          const dayOfWeek = date.getDay();
          return dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 0 && hour < 6
            ? 1.1
            : 0;
        }),
    },
    image: from12amto6am,
    description: 'Recommended!',
  },
];

export default chargingPatterns;
